module.exports = __webpack_public_path__ + "img/bornutti17.592f90a4.jpg";